import { ChangeDetectorRef, Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { employees } from './data/employees';
import { locations } from './data/locations';
import { Employee } from './models/iEmployee';
import { Location } from './models/iLocation';
import { map, startWith } from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { NumberToTextPipe } from './number-to-text.pipe';
import { DecimalOnlyPipe } from './decimal-only.pipe';
import { CommonModule } from '@angular/common';
import { NgxPrintModule } from 'ngx-print';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatToolbarModule,
    MatAutocompleteModule,
    NumberToTextPipe,
    DecimalOnlyPipe,
    NgxPrintModule,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  @ViewChild(MatAutocompleteTrigger)
  emplAutocompleteTrigger: MatAutocompleteTrigger;

  public todayDate = new UntypedFormControl(new Date());

  public employees: Employee[] = [...employees].sort(this.sortByName);
  public locations: Location[] = [...locations].sort(this.sortByName);

  public printForm = this.fb.group({
    employee: null,
    amount: [0],
    date: [new Date()],
    location: null,
    notes: null,
  });

  public filteredOptions: Observable<Employee[]> | undefined;

  public get employee() {
    return this.printForm?.get('employee') as UntypedFormControl;
  }

  public get amount() {
    return this.printForm?.get('amount') as UntypedFormControl;
  }

  public get date() {
    return this.printForm?.get('date') as UntypedFormControl;
  }

  public get location() {
    return this.printForm?.get('location') as UntypedFormControl;
  }

  public get notes() {
    return this.printForm?.get('notes') as UntypedFormControl;
  }

  constructor(private fb: UntypedFormBuilder, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.filteredOptions = this.employee.valueChanges.pipe(
      startWith(''),
      map((employee) => this._filterEmployees(employee || ''))
    );
  }

  public getEmployeeName(employee: Employee): string | null {
    return employee?.name;
  }

  public clearEmployeeInput(): void {
    this.employee.setValue(null);
    this.emplAutocompleteTrigger._onChange(() => {
      this.emplAutocompleteTrigger.openPanel();
    })
  }

  private sortByName(a: Location, b: Location): number {
    const na = a.name.toLowerCase();
    const nb = b.name.toLowerCase();

    if (na < nb) {
      return -1;
    }
    if (na > nb) {
      return 1;
    }
    return 0;
  }

  private _filterEmployees(value: Employee | string): Employee[] {
    let filterValue: string;
    if (typeof value === 'string') {
      filterValue = value.toLowerCase();
    } else if (value && value.name) {
      filterValue = value.name.toLowerCase();
    } else {
      filterValue = '';
    }
    return this.employees.filter(employee => employee.name.toLowerCase().includes(filterValue));
  }

  // public print(): void {
  //   console.log('Print', this.printForm.value);
  // }
}
